import './translations_language_selector.less';

import React from 'react';
import classNames from 'classnames';

import map from 'lodash/map';

import { getSelectorLabelForIso } from 'translations/available_languages.js';


const LanguageSelector = ({
  currentIso,
  forceRight,
  languageOptions,
  shouldShowSelector,
  onLanguageChange
})=> {
  if (!shouldShowSelector) {
    return null;
  }

  return (
    <div className={classNames('language-selector', { 'force-right': forceRight })}>
      <select
        aria-label={getSelectorLabelForIso(currentIso)}
        value={currentIso}
        onChange={(e)=> {
          onLanguageChange(e.target.value);
        }}
      >
        {
          map(languageOptions, ({ label, value })=> (
            <option key={value} value={value}>
              { label }
            </option>
          ))
        }
      </select>
    </div>
  );
};

export default LanguageSelector;
